<button class="userBtn"
        type="button"
        aria-label="Open Main Menu"
        data-test-id="userBtn"
        (click)="isOpened = !isOpened"
        #userBtn>
  <i class="far fa-bars"></i>
  <span class="btn-text d-none--on-old">Menu</span>
</button>

<div class="profileCard"
     [ngClass]="{'active': isOpened}"
     appOutsideClick
     [outsideClickIgnoreEls]="[userBtn]"
     (outsideClicked)="isOpened ? isOpened = false : isOpened">

  <ng-container *ngIf="user">
    <div class="profileCard__header">
      <div class="profileCard__user">
        <div class="profileCard__avatar avatar avatar--sm">
          <span class="avatar__initials">{{user | initials}}</span>
        </div>
        <div class="profileCard__base">
          <span class="profileCard__name">
            {{user?.firstName}} {{user?.lastName}}
          </span>
          <span class="profileCard__email">
            {{user?.email}}
          </span>
        </div>
      </div>
      <button class="profileCard__close"
              type="button"
              aria-label="Close Main Menu"
              (click)="isOpened = false">
        <i class="fal fa-times fa-fw"></i>
      </button>
    </div>
  </ng-container>

  <app-campaign-switcher class="profileCard__select"></app-campaign-switcher>

  <ul class="profileCard__list profileCard__list--campaign pt-0"
      *ngIf="currentCampaign">
    <li class="profileCard__item">
      <a routerLink="/dashboard"
        routerLinkActive="active"
        [queryParams]="{campaignId: currentCampaign.id}"
        queryParamsHandling="replace"
        class="profileCard__link"
        [matTooltip]="'Campaign Dashboard'"
        matTooltipPosition="after"
        matTooltipClass="skinny-nav-link__tooltip">
        <i class="fal fa-gauge-high profileCard__icon  color--blue--003 fa-fw spacerRight"></i>
        <span class="profileCard__label">Dashboard</span>
      </a>
    </li>
    <li class="profileCard__item">
      <a routerLink="/entity/list"
         [queryParams]="{campaignId: currentCampaign.id, clientQueryId: clientQueryId}"
         queryParamsHandling="replace"
         class="profileCard__link"
         [matTooltip]="'Wall Chart'"
         matTooltipPosition="after"
         matTooltipClass="skinny-nav-link__tooltip"
         [ngClass]=" { 'active' : isLinkActive('/entity/') }">
        <i class="fal fa-th-list profileCard__icon profileCard__icon--blue fa-fw spacerRight"></i>
        <span class="profileCard__label">Wall Chart</span>
      </a>
    </li>
    <li class="profileCard__item">
      <a routerLink="/activity/list"
         routerLinkActive="active"
         [queryParams]="{campaignId: currentCampaign.id}"
         queryParamsHandling="replace"
         class="profileCard__link"
         [matTooltip]="'Activity'"
         matTooltipPosition="after"
         matTooltipClass="skinny-nav-link__tooltip">
        <i class="fal fa-history profileCard__icon profileCard__icon--green fa-fw spacerRight"></i>
        <span class="profileCard__label">Activity</span>
      </a>
    </li>
    <li class="profileCard__item">
      <a routerLink="/action/list"
         routerLinkActive="active"
         [queryParams]="{campaignId: currentCampaign.id}"
         queryParamsHandling="replace"
         class="profileCard__link"
         [matTooltip]="'Tasks'"
         matTooltipPosition="after"
         matTooltipClass="skinny-nav-link__tooltip">
        <i class="fal fa-clipboard-check profileCard__icon profileCard__icon--magenta fa-fw spacerRight"></i>
        <span class="profileCard__label">Tasks</span>
      </a>
    </li>
    <li class="profileCard__item"
        *ngIf="showEvents">
      <a routerLink="/events"
         [queryParams]="{campaignId: currentCampaign.id}"
         queryParamsHandling="replace"
         class="profileCard__link"
         [matTooltip]="'Events'"
         matTooltipPosition="after"
         matTooltipClass="skinny-nav-link__tooltip"
         [ngClass]=" { 'active' : isLinkActive('/events/') }">
        <i class="fal fa-calendar-star profileCard__icon profileCard__icon--blue fa-fw spacerRight"></i>
        <span class="profileCard__label">Events</span>
      </a>
    </li>
    <li class="profileCard__item"
        *appIfMinRole="'lead'">
      <a routerLink="/campaign/customize"
         routerLinkActive="active"
         [queryParams]="{campaignId: currentCampaign.id}"
         queryParamsHandling="replace"
         class="profileCard__link"
         [matTooltip]="'Customize'"
         matTooltipPosition="after"
         matTooltipClass="skinny-nav-link__tooltip">
        <i class="fal fa-cogs profileCard__icon profileCard__icon--turquoise fa-fw spacerRight"></i>
        <span class="profileCard__label">Customize</span>
      </a>
    </li>
    <li class="profileCard__item profileCard__item--add-new"
        *appIfMinRole="'organizer'">
      <span class="profileCard__link"
            (click)="openCreateEntityDialog()">
        <i class="fal fa-plus profileCard__icon profileCard__icon--gold fa-fw spacerRight"></i>
        <span class="profileCard__label">Add New&hellip;</span>
      </span>
    </li>
  </ul>

  <app-admin-nav *appIfMinRole="'lead'"></app-admin-nav>

  <ng-container *ngIf="user">
    <h3 class="profileCard__heading">Your Account</h3>
    <ul class="profileCard__list profileCard__list--account">
      <li class="profileCard__item"
          *appIfMinRole="'organizer'">
        <a routerLink="/admin/account/edit/{{user?.id}}"
           routerLinkActive="active"
           class="profileCard__link"
           [matTooltip]="'Edit Your Profile'"
           matTooltipPosition="after"
           matTooltipClass="skinny-nav-link__tooltip">
          <i class="fal fa-address-card profileCard__icon profileCard__icon--turquoise fa-fw spacerRight"></i>
          <span class="profileCard__label">Edit Your Profile</span>
          <i class="fas fa-triangle-exclamation profileCard__icon profileCard__icon--turquoise profileCard__icon-secondary fa-fw spacerLeft" [matTooltip]="'Secure your account with an additional form of verification.'" *ngIf="!user.mfaFactor || user.mfaFactor.status !== 'verified'"></i>
        </a>
      </li>
      <ng-container *appIfInRole="['Activist']">
        <li class="profileCard__item"
          *ngIf="!user.mfaFactor || user.mfaFactor.status !== 'verified'">
          <a routerLink="/setup_mfa"
            class="profileCard__link"
            [matTooltip]="'Setup Multi-Factor Authentication'"
            matTooltipPosition="after"
            matTooltipClass="skinny-nav-link__tooltip">
            <i class="fal fa-shield-alt profileCard__icon profileCard__icon--turquoise fa-fw spacerRight"></i>
            <span class="profileCard__label">Setup 2-Factor Auth</span>
          </a>
        </li>

        <li class="profileCard__item"
          *ngIf="(user.mfaFactor && user.mfaFactor.status === 'verified')">
          <a (click)="removeMfa()"
            class="profileCard__link"
            [matTooltip]="'Remove Multi-Factor Authentication'"
            matTooltipPosition="after"
            matTooltipClass="skinny-nav-link__tooltip">
            <i class="fal fa-shield-alt profileCard__icon profileCard__icon--turquoise fa-fw spacerRight"></i>
            <span class="profileCard__label">Remove 2-Factor Auth</span>
          </a>
        </li>
      </ng-container>
      <li class="profileCard__item">
        <a (click)="resetPassword()"
           class="profileCard__link"
           [matTooltip]="'Change Password'"
           matTooltipPosition="after"
           matTooltipClass="skinny-nav-link__tooltip">
          <i class="fal fa-key profileCard__icon profileCard__icon--gold fa-fw spacerRight"></i>
          <span class="profileCard__label">Change Password</span>
        </a>
      </li>
      <li class="profileCard__item">
        <a class="profileCard__link"
           (click)="logOff()"
           data-test-id="logOffButton"
           [matTooltip]="'Sign Out'"
           matTooltipPosition="after"
           matTooltipClass="skinny-nav-link__tooltip">
          <i class="fal fa-sign-out profileCard__icon profileCard__icon--red fa-fw spacerRight"></i>
          <span class="profileCard__label">Sign Out</span>
        </a>
      </li>
    </ul>
  </ng-container>
  <hr>
  <ul class="profileCard__list profileCard__list--support">
    <li class="profileCard__item">
      <a class="profileCard__link"
         (click)="openSupportDialog()"
         [matTooltip]="'Need Support?'"
         matTooltipPosition="after"
         matTooltipClass="skinny-nav-link__tooltip">
        <i class="fal fa-headset profileCard__icon profileCard__icon--blue fa-fw spacerRight"></i>
        <span class="profileCard__label">Need Support?</span>
      </a>
    </li>
    <li class="profileCard__item d-none--on-old">
      <a class="profileCard__link"
         (click)="showFooter()"
         [matTooltip]="'About Action Builder'"
         matTooltipPosition="after"
         matTooltipClass="skinny-nav-link__tooltip">
        <i class="fal fa-info-circle profileCard__icon profileCard__icon--purple fa-fw spacerRight"></i>
        <span class="profileCard__label">About Action Builder</span>
      </a>
    </li>
  </ul>
</div>
